let env
if (process.env.NODE_ENV === 'production') {
  env = require('../../config/prod.env')
} else {
  env = require('../../config/dev.env')
}

export default {
  api_url: env.domain,
  local_api: env.localDomain
}



// WEBPACK FOOTER //
// ./src/utils/global-variable.js